// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'
import config from './config'

const SENTRY_DSN = config.sentry.sentryDsn

if (config.sentry.enabled) {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0,
    // Note: if you want to override the automatic release value, do not set a `release` value here - use the environment variable `SENTRY_RELEASE`, so that it will also get attached to your source maps
  })
}
